import axios from 'axios'
import { getStore, removeStore } from '@/utils/storage'
import qs from 'qs'
import { message } from 'ant-design-vue'
import { config } from './config'
// import configServices from '../static/config.json'
// const cfgServices = process.env.VUE_APP_ENV ? configServices[process.env.VUE_APP_ENV] : configServices['default']
// 实例添加请求拦截器
axios.interceptors.request.use(config => {
  const appId = getStore('appId')
  const industryId = getStore('industryId')
  const accessToken = getStore('privateAccessToken')
  config.headers = {
    ...config.headers,
    appId,
    industryId,
    accessToken,
    clientType: '3'
  }
  return config

}, err => {
  return Promise.reject(err)
})

// 实例添加响应拦截器
axios.interceptors.response.use(response => {
  // console.log(response);
  errorHandle(response)
  // 返回的数据去掉一层data
  return response.data;
}, err => {
  // 返回的数据去掉一层data
  return Promise.reject(err.response)
})

// 处理错误状态：
const codeMessage = {
  9900: '您的登录已失效，请重新登录',
  9901: '您的登录已失效，请重新登录',
  9040: '服务器异常'
}
const errorHandle = response => {
  let code = response.data.code

  // // 错误状态提示
  // codeMessage[code] && message.warning(codeMessage[code])

  if (code === 9900 || code === 9901) {
    removeStore('privateAccessToken')
    sessionStorage.removeItem('subCode')
    let getLinkCode = getStore('setLinkCode')
    if( getLinkCode &&  getLinkCode !== 'undefined'){
      window.location.replace(`${window.location.origin}/auth/login/${getLinkCode}`)
    } else {
      window.location.reload()
    }
  }
}

const HEADERS = {}
// 文本格式
const Content_Type = {
  'json': 'application/json;charset=utf-8',
  'formdata': 'application/x-www-form-urlencoded;charset=utf-8'
}
export const request = async({
  baseURL = '',
  url = '',
  params = {},
  method = 'get',
  headers = HEADERS,
  data = {},
  timeout = 1000 * 20,
  contentType = "json"
} = {}) => {

  if(baseURL == 'sdkAppId' || baseURL == 'ifm' || baseURL == 'faceService'  || baseURL == 'mApi'  || baseURL == 'filesUpload'  || baseURL == 'smartHome'|| baseURL == 'lanTalkWebSocket'|| baseURL == 'lanTalk'|| baseURL == 'h5View'|| baseURL == 'baiduAk'  ){
    // 兼容性问题短期解决方案
    const configServices = config
    const cfgServices = (process.env.VUE_APP_ENV ? configServices[process.env.VUE_APP_ENV] : configServices['default']) || configServices['default']
    const BASE_URL = cfgServices[process.env.VUE_APP_MODE] ? cfgServices[process.env.VUE_APP_MODE] : cfgServices['development']
    baseURL = (baseURL && BASE_URL[baseURL]) || baseURL || BASE_URL['main']
  }else{
    // // 正常模式
    // const configServices = await axios.get('/config/config.json')
    // const dynamicLink = `${document.location.protocol}//${document.location.hostname}:${configServices.port}`
    // const targetBaseUrl = process.env.VUE_APP_MODE == 'development' || process.env.VUE_APP_MODE == 'dev' ? configServices["default"]['development'].common : dynamicLink
    // baseURL = targetBaseUrl
    // 兼容性问题短期解决方案
    const configServices = config
    const cfgServices = (process.env.VUE_APP_ENV ? configServices[process.env.VUE_APP_ENV] : configServices['default']) || configServices['default']
    const BASE_URL = cfgServices[process.env.VUE_APP_MODE] ? cfgServices[process.env.VUE_APP_MODE] : cfgServices['development']
    baseURL = (baseURL && BASE_URL[baseURL]) || baseURL || BASE_URL['common']
  }

  data = contentType === 'formdata' ? qs.stringify(data) : data
  headers['Content-Type'] = Content_Type[contentType]

  let promise = new Promise((resolve, reject) => {
    axios({
      url: url,
      baseURL: baseURL,
      method: method,
      headers: headers,
      params: params,
      data: data,
      timeout: timeout,
      withCredentials: true
    }).then((res) => {
      resolve(res);
    }, (err) => {
      reject(err)
    })
  });
  return promise
}
